module.exports = __webpack_public_path__ + "_/_/src/demo/src/catalog/items/hanger/hanger.png";


//////////////////
// WEBPACK FOOTER
// ./src/demo/src/catalog/items/hanger/hanger.png
// module id = 570
// module chunks = 0